import { Filter, SortOption } from '../filters/filters';
import { Language } from '../../constants/language';
import { Product } from './product';

export interface Translator {
  name: string;
  bio?: string;
}

export interface Book extends Product{
  author: string;
  
  isbn?: string;
  // Publishing Details
  publisher: string;
  publishedDate: string;
  language: Language;
  
  bookFormat?: BookFormat;
  bookCategory?: BookCategory;
  bestseller?: boolean;
  newRelease: boolean;

  previewPages?: string[]; // Sample pages URLs
  tableOfContents?: string[];
  pages?: number;
  
  authorBio?: string;
  
  // Translation properties - for translated books
  translators?: Translator[];
  originalTitle?: string;
  originalLanguage?: Language;
  translationNotes?: string;
  
  dimensions?: {
    height: number;
    width: number;
    depth: number;
  };
  weight?: number; // in grams
}

export interface BookFilter extends Filter {
  author?: string[];
  publisher?: string[];
  format?: BookFormat[];
  category?: BookCategory[];
}

export interface BookSortOption extends SortOption {
  field: 'name' | 'author' | 'price' | 'rating' | 'publishedDate' | 'createdAt';
}


export enum BookCategory {
  THEOLOGY = 'theology',
  BIBLICAL_STUDIES = 'biblical-studies',
  CHRISTIAN_LIVING = 'christian-living',
  DEVOTIONAL = 'devotional',
  PRAYER = 'prayer',
  WORSHIP = 'worship',
  MINISTRY = 'ministry',
  EVANGELISM = 'evangelism',
  DISCIPLESHIP = 'discipleship',
  SPIRITUAL_GROWTH = 'spiritual-growth',
  FAMILY = 'family',
  YOUTH = 'youth',
  CHILDREN = 'children',
  BIOGRAPHY = 'biography',
  HISTORY = 'history',
  REFERENCE = 'reference',
  FICTION = 'fiction'
}

export enum BookFormat {
  PHYSICAL = 'physical',
  DIGITAL = 'digital',
  BOTH = 'both'
}

